import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** リース申請種類 */
enum LaLedgerApplicationType {
  laContractLedger = 'LA_CONTRACT_LEDGER',
  laArticleLedger = 'LA_ARTICLE_LEDGER',
}

const nameConfig = {
  laContractLedger: new Map([[Locale.ja, '契約台帳']]),
  laArticleLedger: new Map([[Locale.ja, '物件台帳']]),
};

const toEnum = rawValueToEnum(LaLedgerApplicationType, LaLedgerApplicationType.laContractLedger);
const toDisplay = enumToName(LaLedgerApplicationType, nameConfig);
const toDisplayWithPrefix = enumToName(LaLedgerApplicationType, nameConfig, { prefix: true });

export const laLedgerApplicationType = {
  enum: LaLedgerApplicationType,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { LaLedgerApplicationType };
